import { observable, action, reaction, computed, toJS, makeObservable } from 'mobx';
import axios from 'axios';

class configStore {
  route="";
  layout_editor=false;
  actionsHandler=null;
  config={
    inited:false,
    fetching:false,
    data:{},
  };
  useRouter=false;

  par=null;
  constructor(par) {
    makeObservable(this,{
      useRouter:observable,
      route:observable,
      config:observable,
      fields_by_code:computed,
      layout:computed,
      layout_by_code:computed,
      layout_editor:observable,
    });

    this.par=par;
  }
  setConfig(cfg) {
    this.config={
      inited: true,
      fetching: false,
      data:cfg
    }
    console.log('CONFIG',toJS(this.config));
  }
  removeFieldFromLayout(code)
  {
    if(this.layout_by_code[code] && this.fields_by_code[code]) {
      for(let i in this.config.data.layout) {
        if(this.config.data.layout[i] === code) {
          this.config.data.layout.splice(i,1);
          break;
        }
      }
    }
  }
  addFieldToLayout(code) {
    if(!this.layout_by_code[code] && this.fields_by_code[code]) {
      this.config.data.layout.push(code);
      this.par.dataStore.refreshData();
    }
  }
  get layout() {
    if(this.config.inited) {
      const iReturn=[];
      for(let i in this.config.data.layout) {
        const fieldCode=this.config.data.layout[i]
        if(this.fields_by_code[fieldCode]) {
          iReturn.push(this.fields_by_code[fieldCode]);
        }
      }
      return iReturn;
    }
    return [];
  }
  get layout_by_code() {
    if(this.config.inited) {
      const iReturn = {};
      for (let i in this.config.data.layout) {
        iReturn[this.config.data.layout[i]]=1;
      }
      return iReturn;
    }
    return {};
  }
  get fields_by_code() {
    const byCode={};
    if(this.config.data.fields) {
      for(let i in this.config.data.fields) {
        byCode[this.config.data.fields[i].code]=this.config.data.fields[i];
      }
    }
    return byCode;
  }
  moveColumn(what,to,pos) {
    let plus=0;
    if(pos=='before' && what<to) {
      plus=-1;
    }
    if(pos=='after' && what>to) {
      plus = 1;
    }
    this.config.data.layout.splice(to+plus,0,this.config.data.layout.splice(what,1)[0])
  }
  saveLayout(all) {
    axios.post('/eva2/ajax/userApi.php?operation=saveBlenderLayout',{
      layout:toJS(this.config.data.layout),
      all:all,
      type:this.config.data.layout_marker
    }).then(()=>{
      this.layout_editor=false;
    });
  }
  loadConfig() {
    if(this.route) {
      this.config.fetching = true;
      axios.get(this.route).then((data) => {
        this.config.data = data.data.answer;
        this.config.fetching = false;
        this.config.inited = true;
      });
    }
  }
}

/*decorate(configStore,{
  route:observable,
  config:observable,
  fields_by_code:computed,
  layout:computed,
  layout_by_code:computed,
  layout_editor:observable,
});*/

export default configStore;
